<app-top-header></app-top-header>
<div class="page-content">
	<app-navbar></app-navbar>
	<div class="content-wrapper adjecent_content" id="mainTheme">
		<div class="content-inner">
			<main class="route-content">
				<router-outlet></router-outlet>
			</main>

			<!-- Footer -->
			<app-footer></app-footer>
			<!-- /footer -->

		</div>
	</div>
</div>
